<template lang="html">
  <UBadge
    v-if="label"
    :color="badgeColor"
    variant="solid"
    size="sm"
    class="promo-badge"
  >
    <span class="inline-flex items-center gap-1">
      <UIcon v-if="cashback" name="i-lucide-coins" class="size-3" />
      {{ label }}
    </span>
  </UBadge>
</template>

<script setup lang="ts">
const props = defineProps<{
  badge?: string | null
  cartPromo?: boolean
  cashback?: boolean
}>()

const label = computed(() => {
  if (props.badge) {
    return props.badge
  }

  if (props.cartPromo) {
    return 'Акция в корзине'
  }

  return null
})

const badgeColor = computed(() => {
  if (props.cashback) {
    return 'info'
  }

  return 'error'
})
</script>
